import { ComponentProps, useEffect, useState } from 'react'

import {
  Breakpoints,
  MediaQueries,
  ThemeProps,
} from '@hhgtech/hhg-components/misc'
import { AdBlock } from 'components/molecules/adBlock'
import { getMetaTag } from 'components/templates/article/utils'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import innertext from 'innertext'
import { Article } from 'interfaces/types'
// import { useIntl } from 'react-intl'
import styled from 'styled-components'
import {
  getAdTag,
  getCategorySlugFromArticleSlug,
  getCountryAdTag,
  getLocaleCategoryAdTag,
} from 'utils/ads'

const showMastheadAd = true
export const MastheadAd = ({
  adUnitPath,
  customTargetting,
  isSponsored,
  defaultNoScroll,
  initialSticky = false,
  className,
}: {
  adUnitPath: string
  customTargetting?: ComponentProps<typeof AdBlock>['customTargetings']
  isSponsored?: boolean
  defaultNoScroll?: boolean
  initialSticky?: boolean
  className?: string
}) => {
  // const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  const [showPadding, setShowPadding] = useState(false)
  const [sticky, setSticky] = useState(initialSticky)
  useEffect(() => {
    let timeoutValue: ReturnType<typeof setTimeout> | null = null
    const checkShowPadding = () => {
      const divAd = document.querySelector('[id^=super-masthead-ad-]')
      if ((divAd?.getBoundingClientRect().height || 0) > 10) {
        setShowPadding(true)
      } else {
        setShowPadding(false)
      }
      timeoutValue = setTimeout(checkShowPadding, 1000)
    }
    timeoutValue = setTimeout(checkShowPadding, 1000)

    window.googletag = window.googletag || { cmd: [] }
    const { googletag } = window
    googletag.cmd.push(() => {
      googletag.pubads().addEventListener('slotRenderEnded', (e: any) => {
        if (e.slot?.getSlotElementId().startsWith('super-masthead-ad')) {
          setTimeout(() => {
            setSticky(false)
          }, 4000)
          setTimeout(() => {
            document.querySelector('html')?.classList.remove('ad-noscroll')
          }, 700)
        }
      })
    })

    // backup in case get adBlock, ad load failed
    setTimeout(() => {
      document.querySelector('html')?.classList.remove('ad-noscroll')
    }, 1500)

    return () => {
      if (timeoutValue) {
        clearTimeout(timeoutValue)
      }
    }
  }, [])

  return (
    showMastheadAd && (
      <MastheadAdContainer
        data-visible={showPadding}
        data-sponsored={isSponsored}
        data-sticky={sticky}
        className={className}
      >
        {defaultNoScroll && (
          <script
            async
            dangerouslySetInnerHTML={{
              __html: `
                if (window.innerWidth > ${Breakpoints.BREAK_POINT_MOBILE}) {
                  document.querySelector('html')?.classList.add('ad-noscroll')
                }
              `,
            }}
          />
        )}
        {/* {showPadding && (
          <StyledAdHeader>
            <img loading="lazy" src="/svg/adsIcon.svg" alt="" />
            <span>
              {f({ id: 'adBanner.title', defaultMessage: 'Advertisement' })}
            </span>
          </StyledAdHeader>
        )} */}
        <AdBlock
          adUnitPath={adUnitPath}
          size={
            isMobile
              ? [
                  [414, 200],
                  [375, 188],
                  [1, 1],
                ]
              : [
                  [970, 250],
                  [1, 1],
                ]
          }
          divId={`super-masthead-ad-${isMobile ? 'mobile' : 'desktop'}-${
            customTargetting?.Content_ID
          }`}
          pos={['masthead']}
          key={String(isMobile)}
          customTargetings={customTargetting}
          contentId={String(customTargetting?.Content_ID)}
          // adDefaultSize={[0, 0]}
          // noWrapper
          // showCloseBtn
          // wrapperProps={{ m: 0 }}
          onlyRefreshInview
          refreshInterval={30}
        />
      </MastheadAdContainer>
    )
  )
}

export const ArticleMastheadAd = ({
  article,
  defaultNoScroll,
  className,
  initialSticky,
}: {
  article: Article
  defaultNoScroll?: boolean
  initialSticky?: boolean
  className?: string
}) => {
  const { locale } = useRouterExtend()
  const isMobile = useIsMobile()
  if (!article) return null
  const contentAdTag = getLocaleCategoryAdTag(
    locale,
    getCategorySlugFromArticleSlug(article.permalink),
  )
  const adUnitPath = getAdTag({
    countryAdTag: getCountryAdTag(locale, {
      isMobile,
    }),
    contentAdTag,
  })

  const customTargetting = {
    Is_Sponsored: [article.isSponsored ? 1 : 0],
    Is_Expert_Article: [
      article.expert?.id ||
      (article.articleReviewed?.expert?.ID &&
        article.articleReviewed?.is_author)
        ? 1
        : 0,
    ],
    // Is_Affiliate: [article.hasAffiliate ? 1 : 0],
    Keywords: [
      innertext(getMetaTag(article.metaTag || '', 'content_tags') || ''),
    ],
    Content_ID: String(article.id),
  }
  return (
    <MastheadAd
      adUnitPath={adUnitPath}
      customTargetting={customTargetting}
      isSponsored={!!article.isSponsored}
      defaultNoScroll={defaultNoScroll}
      initialSticky={initialSticky}
      className={className}
    />
  )
}

export const MastheadAdContainer = styled.div`
  background: ${(props: ThemeProps) => props.theme?.colors.neutral50};
  &[data-visible='true'] {
    padding: 1rem 0;
    &[data-sponsored='true'] {
      padding: 0 0 1rem;
    }
  }
  ${MediaQueries.mbDown} {
    &[data-sticky='true'] {
      position: sticky;
      top: 0;
      z-index: 999;
      width: 100%;
    }
  }
`
